/**
 * 7 бизнесов экосистемы Luna Protokol.
 *
 * Источник: ТЗ Luna `/luna-protokol/TZ.html`. Каждый бизнес генерит
 * транзакции, которые ноды (LPS) пользователя обрабатывают и за это
 * получают комиссию. Bonds: emoji, hue (HSL для кружков на orbit),
 * описание (показывается в попапе при тапе на маленькую ноду).
 *
 * Порядок ВАЖЕН — он соответствует индексам в TerminalLog,
 * NodeOrbit, LiveFeedTicker и server-side dashboardFeedService.
 */

// Imported as URLs by Vite — each .webp is hashed and served from
// /assets at build time. ~6 KB each, transparent background.
import tmIcon from '@/assets/business-icons/tm.webp';
import vpnIcon from '@/assets/business-icons/vpn.webp';
import pfIcon from '@/assets/business-icons/pf.webp';
import stIcon from '@/assets/business-icons/st.webp';
import csIcon from '@/assets/business-icons/cs.webp';
import aiIcon from '@/assets/business-icons/ai.webp';
import adIcon from '@/assets/business-icons/ad.webp';

export interface BusinessInfo {
  short: string;
  emoji: string;
  name: string;
  description: string;
  /** HSL hue used by NodeOrbit's <circle stroke> for the small ring */
  hue: number;
  /** Generated PNG→WebP icon (256×256, transparent background) */
  icon: string;
}

export const BUSINESSES: readonly BusinessInfo[] = [
  {
    short: 'TM',
    emoji: '📹',
    name: 'TeleMeet',
    description:
      'Видеоконференции — аналог Zoom. Ваши ноды обрабатывают транзакции от подписок, платных тарифов и комнат.',
    hue: 200,
    icon: tmIcon,
  },
  {
    short: 'VPN',
    emoji: '🔐',
    name: 'VPN-сервис',
    description:
      'VPN через все блокировки. Транзакции от подписок и pay-per-traffic трафика.',
    hue: 160,
    icon: vpnIcon,
  },
  {
    short: 'PF',
    emoji: '🌸',
    name: 'Парфюмерия',
    description:
      'Парфюмерия с феромонами. Транзакции от заказов в e-commerce магазине.',
    hue: 320,
    icon: pfIcon,
  },
  {
    short: 'ST',
    emoji: '💎',
    name: 'Стейкинг',
    description:
      'Система стейкинга (Lunar, Star, Marathon). Транзакции от входящих операций, наград и компаунда.',
    hue: 50,
    icon: stIcon,
  },
  {
    short: 'CS',
    emoji: '🎰',
    name: 'Казино',
    description:
      'Онлайн-казино с RTP 97%. Транзакции от ставок, выплат и джекпотов.',
    hue: 0,
    icon: csIcon,
  },
  {
    short: 'AI',
    emoji: '🤖',
    name: 'Jarvis AI',
    description:
      'AI-ассистент в Telegram. Транзакции от запросов, подписок и платных моделей.',
    hue: 270,
    icon: aiIcon,
  },
  {
    short: 'AD',
    emoji: '📺',
    name: 'Ads & Tasks',
    description:
      'Задания и рекламный доход. Транзакции от показов, конверсий и партнёрских кампаний.',
    hue: 100,
    icon: adIcon,
  },
] as const;
